import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { useCustomToast } from 'hooks';
import { deletePolicy } from 'modules/settings/api';

export const useMutationDeletePolicy = () => {
  const { t } = useTranslation();

  const { successToast, errorToast } = useCustomToast();
  const queryClient = useQueryClient();

  return useMutation(deletePolicy, {
    onSuccess: () => {
      successToast(t('Cancellation policy successfully deleted'));
      queryClient.invalidateQueries(QUERY_KEYS.SETTINGS_CANCELLATION_POLICIES);
    },
    onError: () => errorToast(),
  });
};
